import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/4YWxpYRVWvWhebcgYXkofj/ChatGPT_Image_Jun_14,_2026,_06_55_09_PM.png';
export function Logo({
  size = 'md',
  showText = true,
  className = ''
}: LogoProps) {
  // Heights for the full lockup (mark + wordmark) vs. mark-only crop
  const heights = {
    sm: showText ? 36 : 30,
    md: showText ? 48 : 42,
    lg: showText ? 68 : 60
  };
  const height = heights[size];
  // The uploaded asset is a wide TALAB wordmark with generous whitespace.
  // Full lockup: contain the whole wordmark. Mark-only: crop to the leading letter.
  return <div className={`flex items-center ${className}`} data-id="element-2049">
      {showText ? <img src={LOGO_SRC} alt="TALAB" className="object-contain" style={{
      height: height * 1.6,
      width: 'auto',
      marginTop: -height * 0.3,
      marginBottom: -height * 0.3
    }} data-id="element-2050" /> : <div className="overflow-hidden" style={{
      height,
      width: height
    }} data-id="element-2051">
          <img src={LOGO_SRC} alt="TALAB" className="object-cover" style={{
        height,
        width: height * 3,
        objectPosition: '22% center'
      }} data-id="element-2052" />
        </div>}
    </div>;
}